export enum keyCodes {
  tab = 9,
  enter = 13,
  escape = 27,
  space = 32,
  arrowUp = 38,
  arrowDown = 40,
}

export const isEventKey = (e: KeyboardEvent, code: number) => {
  // TODO: migrate
  return e.keyCode === code || e.which === code;
};
